export default __webpack_public_path__ + "static/media/endWork.eb65a663.mp3";